// Per-route SEO metadata. The data lives in seoMap.json so a single source of
// truth is shared by the runtime <Seo> component AND the build-time prerender
// generator (scripts/gen-prerender-meta.mjs) — otherwise the two would drift.
//
// Titles ~50–60 chars, descriptions ~150–160 chars — the lengths Google renders
// without truncation. Dynamic pages (blog posts, cert programmes) pass explicit
// overrides via <Seo title=… description=… />.

import seoMap from './seoMap.json'

export const ORIGIN = seoMap.origin
export const SITE_NAME = seoMap.siteName
export const DEFAULT_IMAGE = seoMap.defaultImage
export const DEFAULT_SEO = seoMap.default
export const SEO_MAP = seoMap.routes

// Resolve the effective SEO for a pathname, honouring explicit overrides.
export function resolveSeo(pathname, overrides = {}) {
  const base = SEO_MAP[pathname] || DEFAULT_SEO
  const canonicalPath =
    pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
  return {
    title: overrides.title || base.title,
    description: overrides.description || base.description,
    image: overrides.image || DEFAULT_IMAGE,
    canonical: `${ORIGIN}${canonicalPath}`,
    noindex: Boolean(overrides.noindex),
    type: overrides.type || 'website',
  }
}
